import MapboxDraw from '@mapbox/mapbox-gl-draw';

/** Point mapbox-gl-draw CSS classes at MapLibre so controls render correctly. */
export function applyMapLibreDrawShim(): void {
  const constants = (MapboxDraw as unknown as { constants: { classes: Record<string, string> } }).constants;
  constants.classes.CANVAS = 'maplibregl-canvas';
  constants.classes.CONTROL_BASE = 'maplibregl-ctrl';
  constants.classes.CONTROL_PREFIX = 'maplibregl-ctrl-';
  constants.classes.CONTROL_GROUP = 'maplibregl-ctrl-group';
  constants.classes.ATTRIBUTION = 'maplibregl-ctrl-attrib';
}
